import { useEffect, useState } from 'react';
import { TABLE_ID } from '../constants';
import { ConfiguratorData } from '../lib/data';
import { ConfiguratorResultData } from '../types';

const configuratorDataFetcher = new ConfiguratorData(TABLE_ID);

export const useData = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);
	const [data, setData] = useState<ConfiguratorResultData>();

	useEffect(() => {
		getData();
	}, []);

	const getData = async () => {
		try {
			setIsLoading(true);
			setIsError(false);

			const data = await configuratorDataFetcher.getData();

			setData(data);
		} catch (error) {
			console.log('Failed to get data:', error);
			setIsError(true);
		} finally {
			setIsLoading(false);
		}
	};

	return {
		isLoading,
		isError,
		data,
	};
};
